export const FACEBOOK_APP_ID = {
  prod: '209262429668637',
  test: '141985423318528',
};

export const GTM_ID = {
  prod: 'GTM-KW9DQJV',
  dev: 'GTM-5KJGHHD',
};
